/** @module csi/widget/_svg/3DBrowser **/
define([
	"dojo/_base/lang",
	"dijit/form/DropDownButton",
	"./_Plugin",
	"./PluginFactory",
	"./_3DBrowserMixin",
], function(lang,DropDownButton,_Plugin,PluginFactory,ThreeDBrowserMixin) {

	return PluginFactory.declare([DropDownButton, _Plugin, ThreeDBrowserMixin], {
		materialIcon:"3d_rotation",
		pluginName: "3DBrowse",
		title: "CanvasUpload3D",
		"class": "csi-3d-browser",

		/** @property {Nodes} modelStore - store of 3d documents available for canvas */
		modelStore: null,

		/** @property {string} viewId */
		viewId: "CanvasUpload3D",

		/** @property {string} storeName */
		storeName: "modelStore",

		startup: function() {
			this.inherited(arguments);
			this.threeDBrowserDropDownMenu().then((result) => {
				this.dropDown = result;
			});
		},
	});
});
